import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api from "@/lib/api";

export default function GiftSent() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const nav = useNavigate();
  const [state, setState] = useState("checking"); // checking | delivered | error
  const [viewUrl, setViewUrl] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!sid) { setErr("Missing session id."); setState("error"); return; }
    const poll = async () => {
      try {
        const { data } = await api.post(`/gifts/finalize/${sid}`);
        if (data.status === "delivered" || data.status === "viewed") {
          setViewUrl(data.view_url);
          setState("delivered");
          return;
        }
        // payment still pending — try a few times
        setTimeout(poll, 2000);
      } catch (e) {
        setErr(e?.response?.data?.detail || "Could not confirm payment.");
        setState("error");
      }
    };
    poll();
  }, [sid]);

  const copy = () => {
    if (!viewUrl) return;
    navigator.clipboard.writeText(viewUrl);
    toast.success("Gift link copied.");
  };

  return (
    <div style={{ maxWidth: 520, margin: "80px auto", padding: 30, textAlign: "center" }}>
      {state === "checking" && (
        <>
          <div className="shimmer" style={{ height: 200, borderRadius: 14, marginBottom: 20 }} />
          <div className="muted">Confirming payment and sending your gift…</div>
        </>
      )}
      {state === "delivered" && (
        <>
          <div style={{ fontSize: 56, color: "var(--gold)", marginBottom: 14 }}>✓</div>
          <div className="serif" style={{ fontSize: 30, color: "#fff", marginBottom: 8 }}>Gift ready</div>
          <div className="muted" style={{ marginBottom: 20 }}>Copy the link below and share it however you like — text, email, WhatsApp, Messenger. If you chose email delivery, the recipient has also been emailed directly.</div>
          {viewUrl && (
            <div className="bg-card" style={{ padding: 18, marginBottom: 18, wordBreak: "break-all", fontSize: 13, color: "#ccc" }}>
              {viewUrl}
            </div>
          )}
          <div style={{ display: "flex", gap: 10, justifyContent: "center", flexWrap: "wrap" }}>
            <button data-testid="copy-gift-link" onClick={copy} className="btn-ghost">Copy gift link</button>
            <button onClick={() => nav("/dashboard")} className="btn-gold">Back to dashboard</button>
          </div>
        </>
      )}
      {state === "error" && (
        <>
          <div style={{ fontSize: 50, color: "#FF6347", marginBottom: 12 }}>✖</div>
          <div className="serif" style={{ fontSize: 26, color: "#fff", marginBottom: 8 }}>Something went wrong</div>
          <p className="muted">{err}</p>
          <button onClick={() => nav("/dashboard")} className="btn-gold" style={{ marginTop: 18 }}>Back to dashboard</button>
        </>
      )}
    </div>
  );
}
